module.exports = __webpack_public_path__ + "static/img/a021.9f2bfd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a021.jpg
// module id = qMuV
// module chunks = 0